import React from "react"

const ArticleContent: React.FC = ({ children }) => (
  <div className="article-content">{children}</div>
)

export default ArticleContent
